import { useState, useRef } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useSnapshot } from 'valtio'
import { windowSizeState } from '../utils/windowSize'
import { proxyState } from '../App'

// image
import enTitle from '../assets/image/20230413_compuer UI -86.png'
import leftTree from '../assets/image/20230413_compuer UI -94.png'
import infoPeople from '../assets/image/89-89-89.png'
import visitButton from '../assets/image/visit2-70.png'
import title1 from '../assets/image/title1-26.png'
import title2 from '../assets/image/title2-27.png'
import subtitle from '../assets/image/20230413_compuer UI -93.png'
import middleTopTree from '../assets/image/20230413_compuer UI -95.png'
import middleBottomTree from '../assets/image/20230413_compuer UI -96.png'
import enButton from '../assets/image/button01-29.png'
import zhButton from '../assets/image/cn-29.png'
import enButtonActive from '../assets/image/o1-104.png'
import zhButtonActive from '../assets/image/o1-105.png'
import infoSubtitle from '../assets/image/擷取-02.png'
import QRCode from '../assets/image/20230413_compuer UI -98.png'
import mobileEnTitle from '../assets/image/20230328_ phone ui-79.png'
import mobileQRCode from '../assets/image/20230328_ phone ui-87.png'
import rotateImage from '../assets/image/ph.png'

const InfoPage = () => {
  const { visible, language } = useSnapshot(proxyState.infoPage)
  const [isBgAnimationComplete, setIsBgAnimationComplete] = useState(false)
  const enInfoRef = useRef(null)
  const { mobileMode, phoneMode, infoPCMode } = useSnapshot(windowSizeState)

  // 主背景動畫結束後才出現按鈕
  const handleDisplayButton = () => {
    setIsBgAnimationComplete(true)
  }

  const scrollToEnInfo = () => {
    enInfoRef.current.scrollIntoView({ behavior: 'smooth' })
  }

  const visitVariants = {
    show: {
      rotate: [3, -3, 3],
      transition: {
        duration: 0.8,
        repeat: Infinity,
      },
      willChange: 'transform', // 加入 willChange 屬性
      layout: 'position', // 加入 layout 屬性
    },
  }

  const visitHoverVariants = {
    opacity: 1,
    rotate: [3, -3, 3],
    transition: {
      duration: 0.3,
      repeat: Infinity,
    },
    willChange: 'transform', // 加入 willChange 屬性
    layout: 'position', // 加入 layout 屬性
  }

  const QRCodeVariants = {
    show: {
      opacity: [0, 0.5, 1],
      transition: {
        duration: 2,
      },
    },
    hidden: {
      opacity: 0,
    },
  }
  return (
    <>
      <AnimatePresence>
        {visible && (
          <>
            <motion.div
              className='main-background h-screen w-screen fixed z-20 flex items-center justify-end overflow-hidden landscapePhone:hidden'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 2.5, delay: 1 }}
              onAnimationComplete={handleDisplayButton}
            >
              <motion.img
                src={!mobileMode ? enTitle : mobileEnTitle}
                alt='主背景英文標題'
                className='absolute w-[15%] top-[27%] left-[6.5%]  xxl:left-[6.5%] xl:left-[5.5%] xl:top-[34%]  mdLg:left-[60%] mdLg:top-[3%] mdLg:w-[28%]'
              />
              <motion.img
                src={leftTree}
                alt='主背景左邊的樹'
                className='absolute w-[2.5%] top-[50%] left-[4%] xxl:top-[52%] xl:top-[55%] xl:left-[2.5%] mdLg:top-[80%] mdLg:left-[5%]  md:top-[83%] z-10 sm:w-[5%] sm:top-[79%] sm:left-[4%]'
              />
              <motion.img
                src={middleTopTree}
                alt='主背景中上的樹'
                className='absolute w-[2.5%] top-[51.5%] left-[23.5%] xxl:top-[53%] xxl:left-[24.5%] xl:top-[57%] xl:left-[25.5%] mdLg:top-[82%] mdLg:left-[35%] md:left-[37%] md:top-[85%] sm:w-[5%] sm:left-[50%] sm:top-[81%] z-10'
              />
              <motion.img
                src={middleBottomTree}
                alt='主背景中下的樹'
                className='absolute w-[3%] top-[69%] left-[23%] xxl:top-[71%] xxl:left-[24%] xl:top-[73%] mdLg:top-[94%] mdLg:left-[35%] md:top-[95%] md:left-[37%] sm:w-[6%] sm:left-[49%] sm:top-[90%] z-10'
              />
              <motion.img
                src={infoPeople}
                alt='簡介標題旁的人'
                className='absolute w-[4.5%] top-[25%] left-[22%] xxl:w-[5%] xxl:left-[22.5%] xl:left-[22%] xl:top-[32%] mdLg:w-[13%] mdLg:left-[80%] mdLg:top-[3%]'
              />
              {!mobileMode && (
                <motion.img
                  src={subtitle}
                  alt='副標'
                  className='absolute w-[21%] bottom-[17%] left-[4.5%]'
                />
              )}
              <motion.img
                src={title1}
                alt='移路'
                className='absolute w-[17%] top-[36%] left-[6.5%]  xxl:w-[19%] xxl:left-[6%] xxl:top-[36%]  xl:w-[21%] xl:left-[5%]  xl:top-[42%] mdLg:top-[72%] mdLg:w-[30%] mdLg:left-[5%] md:top-[75%] md:left-[7%] sm:w-[42%] sm:left-[7%] sm:top-[72%] shortPhone:top-[68%]'
              />
              <motion.img
                src={title2}
                alt='相伴'
                className='absolute w-[17%] top-[55%] left-[6.5%] xxl:w-[19%] xxl:left-[6%] xxl:top-[56%] xl:w-[21%] xl:top-[59%] xl:left-[5%] mdLg:top-[85%] mdLg:w-[30%] mdLg:left-[5%]  md:left-[7%] md:top-[86.5%] sm:w-[42%] sm:left-[7%] sm:top-[82%] shortPhone:top-[80%]'
              />
              {mobileMode && (
                <motion.img
                  src={subtitle}
                  alt='行動版副標'
                  className=' absolute mdLg:w-[40%] mdLg:left-[44%] mdLg:bottom-[13%] sm:left-[9%] sm:bottom-[2%] sm:w-[50%]'
                />
              )}
              {isBgAnimationComplete && mobileMode && (
                <motion.img
                  src={!phoneMode ? QRCode : mobileQRCode}
                  alt='QRCode'
                  className='absolute w-[18%] bottom-8 left-[54%] xxl:left-[50%] xxl:w-[19%] mdLg:w-[35%] mdLg:bottom-[3%] mdLg:left-[43%]  sm:left-[61%] sm:bottom-[1%] sm:w-[38%] cursor-pointer'
                  variants={QRCodeVariants}
                  initial='hidden'
                  animate='show'
                  onClick={() =>
                    window.open(
                      'https://migrationstories10.wixsite.com/jalanjalanexhibition',
                      '_blank'
                    )
                  }
                />
              )}

              <div className=' flex flex-col justify-end w-[66%] h-[66%] mr-16 bg-white bg-opacity-20 p-12 rounded-3xl xl:px-10 xl:py-8 xl:mr-12 mdLg:w-[90%] mdLg:absolute mdLg:left-[5%]  mdLg:top-[14%] mdLg:px-6 mdLg:pt-4 mdLg:pb-6 mdLg:h-[57%] md:h-[54%] shortPhone:h-[51%] '>
                <div className='flex justify-between items-center h-[20%] '>
                  <div
                    className={`flex items-center w-full  ${
                      mobileMode && 'justify-between'
                    }`}
                  >
                    {language === 'zh' ? (
                      <p className='text-[40px] text-homepageOrange-100 font-bold tracking-[8px] xl:text-[38px] mdLg:text-[34px] sm:text-[30px] mr-3'>
                        展覽總論
                      </p>
                    ) : (
                      <p className='text-[32px] text-homepageOrange-100 font-bold tracking-[1px]  xl:text-[24px]  mdLg:text-[32px] smMd:text-[24px] sm:text-[20px] sm:mr-0 mr-3'>
                        Exhibition Summary
                      </p>
                    )}

                    <div
                      className={` flex items-center sm:w-[60px]  ${
                        infoPCMode && 'flex-col'
                      }`}
                    >
                      <div
                        className={` ${
                          language === 'zh' ? 'w-[110px]' : 'w-[100px]'
                        } smMd:w-[80px] sm:w-[60px]`}
                      >
                        <img
                          src={language === 'zh' ? zhButtonActive : zhButton}
                          alt='中文切換按鈕'
                          onClick={() => (proxyState.infoPage.language = 'zh')}
                          className='cursor-pointer '
                        />
                      </div>
                      <div
                        className={` ${
                          language === 'en' ? 'w-[110px]' : 'w-[100px]'
                        } smMd:w-[80px] sm:w-[60px]`}
                      >
                        <img
                          src={language === 'en' ? enButtonActive : enButton}
                          alt='英語切換按鈕'
                          onClick={() => (proxyState.infoPage.language = 'en')}
                          className='cursor-pointer '
                        />
                      </div>
                    </div>
                  </div>
                  {!mobileMode && (
                    <img
                      src={QRCode}
                      alt='QRCode'
                      className=' w-[270px] xl:w-[200px] cursor-pointer '
                      onClick={() =>
                        window.open(
                          'https://migrationstories10.wixsite.com/jalanjalanexhibition',
                          '_blank'
                        )
                      }
                    />
                  )}
                </div>
                {language === 'zh' && (
                  <div className='w-[100%] right-0 text-[22px] h-[84%] overflow-y-auto mdLg:text-[20px] pl-2 pr-2 tracking-wider'>
                    <p className='text-justify'>
                      高雄市勞工博物館為全國唯一以勞工為主題的博物館，為了促進更多元的族群能入館，增進不同族群的交流，深化外籍移民工議題展示，2021年上半年進行高屏地區10個服務移民/工非政府組織及多處移民/工生活地景的訪調，從高屏地區的移民/工生活地景，看見種種身而為人的需求，與非政府組織工作者如何站在前線陪伴移民工的歷程，因而籌畫「Jalan-Jalan：移路相伴」勞工博物館高屏地區移動人權特展。
                    </p>
                    <br />
                    <p className='text-justify'>
                      印尼語中「Jalan」一詞指街道的意思，當疊字唸作「Jalan
                      Jalan」則帶有邀請的能動性，想與你「出去走走、漫步」的意思，透過「漫步」城市空間，我們途經不同歷史脈絡產生的當代風景，你是否有查覺這些「日常風景」，也是城市中不同族群的「生存風景」？
                    </p>
                  </div>
                )}
                {language === 'en' && (
                  <div className='w-[100%] right-0 text-[22px] h-[86%] overflow-y-auto mdLg:text-[20px] pl-2 pr-2 tracking-wider'>
                    <p
                      ref={enInfoRef}
                      className=' text-[20px] text-justify smMd:text-left'
                    >
                      The Kaohsiung Museum of Labor is Taiwan’s only
                      labor-themed museum. The goal of the museum is to promote
                      diverse groups to visit the museum and increase the
                      exposure of foreign migrant/migrant worker issues. In the
                      first half of 2021, interviews were conducted at 10
                      Kaohsiung/Pingtung areas, including NGO organizations that
                      service migrants/migrant workers and places where
                      migrants/migrant workers frequent in Kaohsiung/Pingtung;
                      we can see what their needs are and how NGO workers stand
                      on the frontlines to accompany them. This is the
                      background for the planning of the “Jalan-Jalan:
                      Companionship Alongside” Special Exhibition on the Human
                      Rights of Migrants in Kaohsiung and Pingtung Area at the
                      Kaohsiung Museum of Labor.
                    </p>
                    <br />
                    <p className=' text-[20px] text-justify smMd:text-left'>
                      “Jalan” means “street” in Indonesian, and “Jalan Jalan”
                      means an invitation for a stroll. Jalan jalan can also
                      mean the person wants to take a walk or a stroll with you.
                      By “strolling” around the city, we can see many
                      contemporary landscapes produced by different histories.
                      Have you noticed that these daily landscapes are also the
                      “living landscape” for different groups in the city?
                    </p>
                  </div>
                )}
              </div>
              {isBgAnimationComplete && (
                <motion.img
                  src={visitButton}
                  alt='進入展場按鈕'
                  className='absolute w-[20%] right-20 bottom-10 cursor-pointer xxl:w-[22%] xl:w-[23%] xl:bottom-18 xl:right-12 mdLg:w-[40%] mdLg:top-[72%] mdLg:right-[5%] sm:w-[52%] sm:top-[70%] shortPhone:top-[67%]'
                  variants={visitVariants}
                  animate='show'
                  whileHover={visitHoverVariants}
                  onClick={() => {
                    let currentUrl = window.location.href // 取得當前網址
                    var newUrl = currentUrl.replace(
                      '/start.html',
                      '/vr/v0.html'
                    ) // 建立新的相對路徑
                    window.location.href = newUrl // 導向新的網頁
                  }}
                />
              )}
            </motion.div>
            <div className='main-background h-screen hidden justify-center items-center portrait:hidden landscapePhone:flex '>
              <img
                src={rotateImage}
                alt=''
                className='w-[70%] h-[70%] object-contain'
              />
            </div>
          </>
        )}
      </AnimatePresence>
    </>
  )
}

export default InfoPage
